// extracted by mini-css-extract-plugin
module.exports = {"toggle":"FilesViewToggle_toggle__Xe72g"};